import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconCompanies = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.858 22.3583C10.735 17.8576 13.3422 9.15395 24.7558 10.3456C26.3909 14.6398 25.6512 24.3128 14.9081 25.8012",
			stroke: "#1D1D1D",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3467 10.7266C20.152 11.7622 22.8208 14.5224 25.1269 15.6403",
			stroke: "#1D1D1D",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19.1881,
			cy: 17.0712,
			r: 1.71273,
			transform: "rotate(71.6127 19.1881 17.0712)",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.2469 18.9306C25.7378 19.7917 26.7012 23.3484 22.8512 27.6897C22.1119 28.5233 21.1475 28.5454 21.3289 27.4461C21.3734 27.1761 21.4309 26.858 21.5034 26.4832C21.955 24.1474 21.019 23.6573 20.8159 23.4942",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2459 12.2767C15.25 11.0588 11.9215 10.7055 8.57288 14.7378C7.86104 15.595 8.01016 16.5129 9.06375 16.1504C9.27238 16.0786 9.51012 15.9937 9.78114 15.894C11.8394 15.1364 12.4243 15.9153 12.6028 16.0759",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4708 24.8733C10.5444 22.8146 9.27107 25.7607 8.74863 27.9788C8.67041 28.3109 8.9554 28.6066 9.28988 28.5394C11.4772 28.0999 14.393 26.9275 12.4708 24.8733Z",
			stroke: "black"
		})
	]
});
export default SvgNaviconCompanies;
